import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { ImageUploaded, ImageUploadedSuccessData } from 'domain/models/image.models'

@Injectable({ providedIn: 'root' })
export class FileService {
  private readonly baseUrl = `${environment.api.baseUrl}/content/v1/medias/upload`

  constructor(private http: HttpClient) {}

  async save(file: File): Promise<ImageUploaded> {
    const formData = new FormData()
    formData.append('file', file, file.name)

    const resp = await firstValueFrom(this.http.post<ImageUploadedSuccessData>(this.baseUrl, formData))
    const imageUploaded: ImageUploaded = {
      url: resp?.success?.[0]?.fileUrl ? resp.success[0].fileUrl : '',
    }

    console.log(imageUploaded)

    return imageUploaded
  }
}
